import { useEffect } from 'react'
import { GENERICS } from '@/resources/dict'
import { CustomMetaTagsProps } from './types'

const updateMetaTag = (selector: string, content: string | undefined) => {
  if (content) {
    document.querySelector(selector)?.setAttribute('content', content)
  }
}

const CustomMetaTags = ({
  title,
  description,
  url = window.location.href,
  children,
}: CustomMetaTagsProps) => {
  useEffect(() => {
    if (title) {
      document.title = title
      updateMetaTag('meta[name="title"]', title)
      updateMetaTag('meta[property="og:title"]', title)
      updateMetaTag('meta[property="twitter:title"]', title)
    }
    if (description) {
      updateMetaTag('meta[name="description"]', description)
      updateMetaTag('meta[property="og:description"]', description)
      updateMetaTag('meta[property="twitter:description"]', description)
    }
    if (url) {
      updateMetaTag('meta[property="og:url"]', url)
      updateMetaTag('meta[property="twitter:url"]', url)
    }
  }, [title, description, url])

  return (
    <>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={GENERICS.customMetaTags.title} />
      <meta
        property="og:description"
        content={GENERICS.customMetaTags.description}
      />
      <meta
        property="og:image"
        content="https://courier-images-web.imgix.net/static/img/meta_image.png?auto=compress,format&fit=max&w=undefined&h=undefined&dpr=2&fm=png"
      />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={GENERICS.customMetaTags.title} />
      <meta
        property="twitter:description"
        content={GENERICS.customMetaTags.description}
      />
      <meta
        property="twitter:image"
        content="https://courier-images-web.imgix.net/static/img/meta_image.png?auto=compress,format&fit=max&w=undefined&h=undefined&dpr=2&fm=png"
      />

      {children}
    </>
  )
}

export default CustomMetaTags
